export const KNOWN_HOSTNAMES: Record<string, string> = {
  github: 'GitHub',
  opencollective: 'Open Collective',
  'ko-fi': 'Ko-fi',
  patreon: 'Patreon',
  buymeacoffee: 'Buy Me a Coffee',
  tidelift: 'Tidelift',
  liberapay: 'Liberapay',
  IssueHunt: 'IssueHunt',
  'open-source': 'Open Source',
}
